import type { QueryClient } from '@tanstack/vue-query'
import type { Router } from 'vue-router'
import { invalidateAdminRequests } from '../api/requestLifecycle'
import { adminQueryClient } from '../queryClient'
import type { useSessionStore } from '../stores/session'

type SessionStore = ReturnType<typeof useSessionStore>

export async function performAdminSafeExit(
  session: SessionStore,
  router: Router,
  queryClient: QueryClient = adminQueryClient,
): Promise<void> {
  invalidateAdminRequests()
  const queryCancellation = queryClient.cancelQueries()
  queryClient.clear()
  session.clearSensitiveState()

  const navigation = router.replace({ name: 'admin-signed-out' })
  await Promise.all([queryCancellation.catch(() => undefined), navigation])
}
